"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import { Popover, PopoverButton } from "@headlessui/react";
import { useThemeStore } from "@/store/theme-store";
import { useEffect, useRef, useState } from "react";
import { ColorDisplayButton } from "./color-display-button";
import { ColorPickerPanel } from "./color-picker-panel";
import { useColorPickerShortcuts } from "@/hooks/use-theme-shortcuts";
import { ColorPickerOptions } from "./color-picker-options";
export const ColorPicker = t0 => {
  const $ = _c(12);
  const {
    title,
    colorKey,
    modifier
  } = t0;
  let t1;
  if ($[0] !== colorKey) {
    t1 = state => state.colors[state.platform][state.theme][colorKey];
    $[0] = colorKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const color = useThemeStore(t1);
  const [popoverWidth, setPopoverWidth] = useState(0);
  const popoverRef = useRef(null);
  useColorPickerShortcuts(modifier);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (popoverRef.current) {
        const width = popoverRef.current.clientWidth + 2;
        setPopoverWidth(Math.max(width, 200));
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const updatePopoverWidth = t2;
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      updatePopoverWidth();
      window.addEventListener("resize", updatePopoverWidth);
      return () => {
        window.removeEventListener("resize", updatePopoverWidth);
      };
    };
    t4 = [];
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cn("group/color-picker", "relative border-l first:border-none", "nth-[3]:border-t nth-[4]:border-t", "md:nth-[3]:border-t-0 md:nth-[4]:border-t-0");
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== color || $[7] !== colorKey || $[8] !== modifier || $[9] !== popoverWidth || $[10] !== title) {
    t6 = <Popover className={t5}>{t7 => {
        const {
          open
        } = t7;
        return <><ColorPickerOptions colorKey={colorKey} /><PopoverButton ref={popoverRef} data-color-picker-modifier={modifier} className={cn("flex w-full items-start justify-between px-4 py-2", "group-hover/color-picker:hover:bg-border/35 group-data-open/color-picker:!bg-border/50", "focus:outline-none data-focus:inset-ring-2 data-focus:inset-ring-blue-500")}><ColorDisplayButton title={title} color={color} colorKey={colorKey} open={open} /></PopoverButton><ColorPickerPanel colorKey={colorKey} width={popoverWidth} /></>;
      }}</Popover>;
    $[6] = color;
    $[7] = colorKey;
    $[8] = modifier;
    $[9] = popoverWidth;
    $[10] = title;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};